import React, { useEffect, useRef } from "react";
import { Button, Stack } from "@mui/material";
import { FaInfoCircle, FaUserPlus } from "react-icons/fa";
import Header from "../../../Header/Header";
import CertificateCard from "../../CertificateCard/CertificateCard";
import Footer from "../../../Footer/Footer";
import SolutionComponent from "./SolutionComponent";
import { useLocation } from "react-router-dom";

const Soution = () => {
  const location = useLocation();
  const index = location.state?.index;

  return (
    <>
      <Header />
      <main>
        <SolutionComponent index={index}/>
        <CertificateCard />
      </main>
      <Footer />{" "}
    </>
  );
};

export default Soution;
